import $ from "jquery";

$(() => {
  let downloadSections = $(".c-downloads");
  if (downloadSections.length) {
    downloadSections.each((i, downloadSectionEl) => {
      const downloadSection = $(downloadSectionEl);
      let langs = [];
      const downloadLanguageSelector = downloadSection.find("#download-language-selector");

      downloadSection
        .find(".c-download--language-section")
        .each(function () {
          var lang = $(this).data("lang");
          if (!langs.includes(lang)) {
            langs.push(lang);
          }
        });
      downloadLanguageSelector.on("change", function () {
        changeVideoLanguage($(this).children("option:selected").val());
      });
      const changeVideoLanguage = function (lang) {
        // cleanup langagues NOT matching this selection
        downloadSection
          .find(".c-download--language-section")
          .each(function () {
            if ($(this).data("lang") != lang) {
              $(this).addClass("hidden");
            } else {
              $(this).removeClass("hidden");
            }
          });
      };
      changeVideoLanguage(langs[0]);
    
      // if there is only one language, don't bother showing an languague selector
      if (langs.length <= 1) {
        $("#download-languages").hide();
      }
    });
  }
});